export enum AccountProperties {
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  User = 'user',
  Devices = 'devices',
  PaymentMethods = 'paymentMethods',
  AccountStatus = 'accountStatus',
  MailingAddress = 'mailingAddress',
  BillableAddress = 'billableAddress',
}
export enum AccountMetaProperties {
  UserId = 'User-id',
  UserVersion = 'User-version',
  DevicesId = 'Devices-id',
  DevicesVersion = 'Devices-version',
  PaymentMethodsId = 'PaymentMethods-id',
  PaymentMethodsVersion = 'PaymentMethods-version',
  MailingAddressId = 'MailingAddress-id',
  MailingAddressVersion = 'MailingAddress-version',
  BillableAddressId = 'BillableAddress-id',
  BillableAddressVersion = 'BillableAddress-version',
}
